import React, { useEffect, useState } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Row,
  Icon,
  Block,
} from "../../components/Component";
import { Card, Spinner } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContactUsDetail } from "../../slice/contact-us-detail";
import { deleteSuccess as deleteContactUsSuccess } from "../../slice/contact-us";
import { deleteContactUs } from "../../api/contact-us";
import moment from "moment";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../admin/modals/DeleteConfimationModal";

const Field = ({ label, children }) => (
  <div className="py-2 border-bottom">
    <div className="text-muted small mb-1">{label}</div>
    <div className="fw-bold text-break" style={{ whiteSpace: "pre-wrap" }}>
      {children}
    </div>
  </div>
);

const ContactUsDetailPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  useEffect(() => {
    dispatch(getContactUsDetail(id));
  }, [id, dispatch]);

  const { item, loading } = useSelector((state) => state.contactUsDetail);

  const onDelete = async () => {
    if (!id) return;
    try {
      await deleteContactUs(id);
      dispatch(deleteContactUsSuccess(id));
      toast.success("Message deleted");
      navigate("/contact-us");
    } catch (error) {
      toast.error(error?.message ?? "Failed to delete message");
    }
  };

  return (
    <React.Fragment>
      <Head title="Contact Us Detail"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>Contact Us Message</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="d-flex" style={{ gap: 8 }}>
                <Link to={`/contact-us`}>
                  <Button color="light" outline className="bg-white">
                    <Icon name="arrow-left"></Icon>
                    <span>Back to list</span>
                  </Button>
                </Link>
                {item && (
                  <Button
                    color="danger"
                    outline
                    onClick={() => setConfirmingDelete(true)}
                  >
                    <Icon name="trash"></Icon>
                    <span>Delete</span>
                  </Button>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {loading && !item ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : !item ? (
            <div className="text-center py-5 text-muted">
              Message not found
            </div>
          ) : (
            <Row className="g-3">
              <Col lg="4">
                <Card className="p-4">
                  <h6 className="title mb-3">Submitter</h6>
                  {item.createdBy?.avatar && (
                    <div className="d-flex justify-content-center mb-3">
                      <img
                        src={item.createdBy.avatar}
                        alt="avatar"
                        width={96}
                        height={96}
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "1px solid #eee",
                        }}
                      />
                    </div>
                  )}
                  <Field label="Name">
                    {item.createdBy?.fullName ?? "Guest"}
                  </Field>
                  {item.createdBy?.businessName && (
                    <Field label="Business name">
                      {item.createdBy.businessName}
                    </Field>
                  )}
                  <Field label="Email">
                    {item.createdBy?.email ?? "N/A"}
                  </Field>
                  <Field label="Role">{item.createdBy?.role ?? "N/A"}</Field>
                  <Field label="Submitted at">
                    {item.createdAt
                      ? moment(item.createdAt).format("DD/MM/YYYY HH:mm")
                      : "N/A"}
                  </Field>
                </Card>
              </Col>
              <Col lg="8">
                <Card className="p-4">
                  <h6 className="title mb-3">Message</h6>
                  <Field label="Subject">{item.subject || "—"}</Field>
                  <Field label="Brief reason for contacting us">
                    {item.reason || "—"}
                  </Field>
                </Card>
              </Col>
            </Row>
          )}
        </Block>
      </Content>
      <DeleteConfirmationModal
        isOpen={confirmingDelete}
        onCloseModal={() => setConfirmingDelete(false)}
        onConfirm={onDelete}
        title="Delete contact us message?"
        desc="The message will be permanently deleted."
      />
    </React.Fragment>
  );
};

export default ContactUsDetailPage;
